declare global {
  interface Window {
    zEACLoaded: boolean;
    zE: (...args: any) => void | undefined;
  }
}

export const ZENDESK_LO_USER_ID = 'logged-out-user';
const ZENDESK_IS_HIDDEN_LS_KEY_PREFIX = 'zendesk.isVisible';

export default class SupportChat {
  private static zendeskUserLsKey: string;

  static async init(userId: string) {
    const { zendeskWidgetUrl } = useRuntimeConfig().public;

    if (!userId) return false;

    this.zendeskUserLsKey = `${ZENDESK_IS_HIDDEN_LS_KEY_PREFIX}-${userId}`;

    if (userId === ZENDESK_LO_USER_ID) {
      SupportChat.isVisible = true;
    }

    return new Promise((resolve, reject) => {
      if (SupportChat.getIsInitialized()) {
        return resolve(true);
      }

      const script = document.createElement('script');
      script.id = 'ze-snippet';
      script.src = zendeskWidgetUrl;
      script.nonce = '{random}';
      script.defer = true;
      script.onload = () => {
        this.zendeskUserLsKey = `${ZENDESK_IS_HIDDEN_LS_KEY_PREFIX}-${userId}`;

        if (!SupportChat.isVisible) {
          SupportChat.hideButton();
        }

        resolve(true);
      };

      script.onerror = (error: Event) => {
        delete this.zendeskUserLsKey;
        reject(error);
      };

      document.body.appendChild(script);
    });
  }

  static getIsInitialized() {
    return window.zEACLoaded;
  }

  static hideButton() {
    try {
      window.zE?.('messenger', 'hide');
      this.isVisible = false;
    } catch (e) {
      console.warn('Failed to hide Zendesk widget:', e);
    }
  }

  static showButton() {
    try {
      window.zE?.('messenger', 'show');
      this.isVisible = true;
    } catch (e) {
      console.warn('Failed to show Zendesk widget:', e);
    }
  }

  static toggle() {
    if (!SupportChat.getIsInitialized()) return;

    if (SupportChat.isVisible) {
      SupportChat.hideButton();
    } else {
      SupportChat.showButton();
    }
  }

  static get isVisible() {
    return sessionStorage.getItem(this.zendeskUserLsKey) === 'true';
  }

  static set isVisible(value) {
    sessionStorage.setItem(this.zendeskUserLsKey, value.toString());
  }
}
